import {TeamOutlined} from '@ant-design/icons'
import Commonview from '../../../pages/common_view';
import UserAccountPage from "../../../pages/user_manage/user_account_page";
import PermissionPage from "../../../pages/user_manage/user_permission_manage";
import UserGroupPage from '../../../pages/user_manage/user_group_manage';

const MemberRouter = [
    {
        path: '/userManage',
        element: <Commonview/>,
        meta: {title: '用户和权限', icon: <TeamOutlined />},
        children: [
            {
                path: '/userManage/userAccountManage',
                meta: {title: '用户管理', key: 'user_account'},
                element: <UserAccountPage/>,
            },
            {
                path: '/userManage/userGroupManage',
                meta: {title: '用户组管理', key: 'user_group'},
                element: <UserGroupPage/>,
            },
            {
                path: '/userManage/permission',
                meta: {title: '权限管理', key: 'user_permission'},
                element: <PermissionPage/>,
            },
        ]
    }
]

export default MemberRouter
